"use strict";

var _toConsumableArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _slicedToArray = require("/Users/janne/dev/c64jasm-browser/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.exportC64debuggerInfo = exports.exportViceMoncommands = exports.toHex16 = void 0;

function toHex16(v) {
  return v.toString(16).padStart(4, '0');
}

exports.toHex16 = toHex16;
;

function isXmlElement(object) {
  if (typeof object === 'object') {
    return 'name' in object;
  }

  return false;
}

function writeXml(xml, write) {
  function recurse(elt, depth) {
    var attrs = Object.entries(elt.attributes).map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      return "".concat(k, "=\"").concat(v, "\"");
    }).join(' ');
    var indent = '  '.repeat(depth);
    write("".concat(indent, "<").concat(elt.name).concat(attrs !== '' ? " ".concat(attrs) : '', ">\n"));

    if (elt.children.length !== 0) {
      if (isXmlElement(elt.children[0])) {
        var _iterator = _createForOfIteratorHelper(elt.children),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var c = _step.value;
            recurse(c, depth + 1);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } else {
        var _indent = '  '.repeat(depth + 1);

        var _iterator2 = _createForOfIteratorHelper(elt.children),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var line = _step2.value;
            write("".concat(_indent).concat(line, "\n"));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }

    write("".concat(indent, "</").concat(elt.name, ">\n"));
  }

  recurse(xml, 0);
}

function exportViceMoncommands(writeSync, labels, debugInfo) {
  var _iterator3 = _createForOfIteratorHelper(labels),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _step3$value = _step3.value,
          name = _step3$value.name,
          addr = _step3$value.addr;
      var msg = "al C:".concat(toHex16(addr), " .").concat(name, "\n");
      writeSync(msg);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  var _iterator4 = _createForOfIteratorHelper(debugInfo.info().breakpoints),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var brk = _step4.value;

      var _msg = "break ".concat(toHex16(brk.addr), "\n");

      writeSync(_msg);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
}

exports.exportViceMoncommands = exportViceMoncommands;

function exportC64debuggerInfo(writeSync, labels, segmentInfos, debugInfo) {
  var sourceIdxByName = {};
  var sources = [];

  for (var i = 0; i < debugInfo.sourceFiles.length; i++) {
    var name = debugInfo.sourceFiles[i];
    sources.push("".concat(i, ",").concat(name));
    sourceIdxByName[name] = i;
  }

  var sortedPC = Object.keys(debugInfo.pcToLocs).map(Number).sort(function (a, b) {
    return a - b;
  });
  var segmentOut = [{
    name: segmentInfos[0].name,
    blocks: [{
      text: []
    }]
  }];
  var blockIdx = [0, 0];

  var _iterator5 = _createForOfIteratorHelper(sortedPC),
      _step5;

  try {
    pcloop: for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var pc = _step5.value;
      var b = segmentInfos[blockIdx[0]].blocks[blockIdx[1]];

      while (true) {
        var si = segmentInfos[blockIdx[0]];
        b = si.blocks[blockIdx[1]];

        if (pc >= b.start && pc <= b.end) {
          break;
        }

        if (pc < b.start) {
          continue pcloop;
        }

        if (blockIdx[1] != si.blocks.length - 1) {
          blockIdx[1] += 1;
          segmentOut[blockIdx[0]].blocks.push({
            text: []
          });
        } else {
          blockIdx[0] += 1;
          blockIdx[1] = 0;

          if (blockIdx[0] >= segmentInfos.length) {
            break pcloop;
          }

          segmentOut.push({
            name: segmentInfos[blockIdx[0]].name,
            blocks: [{
              text: []
            }]
          });
        }
      }

      if (!(pc >= b.start && pc <= b.end)) {
        throw new Error('internal compiler error: inconsistent segments');
      }

      var entry = debugInfo.pcToLocs[pc];
      var outLines = segmentOut[blockIdx[0]].blocks[blockIdx[1]].text;
      var ll = entry[0];
      outLines.push("$".concat(toHex16(pc), ",$").concat(toHex16(pc + ll.numBytes - 1), ",").concat(sourceIdxByName[ll.source], ",").concat(ll.lineNo, ",1,").concat(ll.lineNo, ",1"));
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  var lbls = labels.map(function (_ref3) {
    var name = _ref3.name,
        addr = _ref3.addr,
        segmentName = _ref3.segmentName;
    return "".concat(segmentName, ",$").concat(toHex16(addr), ",").concat(name);
  });
  var segments = segmentOut.map(function (s) {
    return {
      name: 'Segment',
      attributes: {
        name: s.name,
        values: "START,END,FILE_IDX,LINE1,COL1,LINE2,COL2"
      },
      children: s.blocks.map(function (b) {
        return {
          name: 'Block',
          attributes: {},
          children: b.text
        };
      })
    };
  });
  var breakpoints = debugInfo.info().breakpoints.map(function (b) {
    return "".concat(b.segmentName, ",$").concat(toHex16(b.addr), ",");
  });
  writeXml({
    name: 'C64debugger',
    attributes: {
      version: '1.0'
    },
    children: [{
      name: 'Sources',
      attributes: {
        values: 'INDEX,FILE'
      },
      children: sources
    }].concat(_toConsumableArray(segments), [{
      name: 'Labels',
      attributes: {
        values: 'SEGMENT,ADDRESS,NAME'
      },
      children: lbls
    }, {
      name: 'Breakpoints',
      attributes: {
        values: 'SEGMENT,ADDRESS,ARGUMENT'
      },
      children: breakpoints
    }])
  }, function (msg) {
    return writeSync(msg);
  });
}

exports.exportC64debuggerInfo = exportC64debuggerInfo;